"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var constants_1 = require("../../../constants");
var pp_react_1 = require("@paypalcorp/pp-react");
var icons_component_1 = require("../../../components/icons.component");
var interpolate_component_1 = require("../../../components/interpolate-component");
var commonweb_utils_1 = require("commonweb-utils");
function UpdateNameSuccess(_a) {
    var content = _a.content, account = _a.account, route = _a.route, transitionOutHandler = _a.transitionOutHandler;
    var mainLink;
    var exitView = route.exit.view;
    var nameInfo = commonweb_utils_1.objectUtils.safeGet(account, "name");
    var firstname = nameInfo.firstName;
    var lastname = nameInfo.lastName;
    var minorNameSuccessMessage = interpolate_component_1.InterpolateLinksWithComponent(content.name.edit.success, [firstname, lastname]);
    if (route.isFlow) {
        mainLink = constants_1.default.BASE_URI + "/flow-return/" + route.enter.flow;
    }
    else {
        mainLink = "" + constants_1.default.BASE_URI;
    }
    return (React.createElement("div", { className: "generic-container" },
        React.createElement(icons_component_1.IllustrationComponent, { modifierClass: "successImg", image: "Success" }),
        React.createElement(pp_react_1.Text, { size: "xl3", className: "name-header" }, exitView == "update-name-minor"
            ? minorNameSuccessMessage
            : content.name.majorLegalEdit.success),
        React.createElement(pp_react_1.Text, { size: "md", className: "name-content" }, exitView == "update-name-minor"
            ? null
            : content.name.majorLegalEdit.comment),
        React.createElement(pp_react_1.Link, { className: "vx_btn vx_btn-block", href: mainLink, onClick: transitionOutHandler },
            React.createElement(pp_react_1.Text, { size: "md", className: "ok-button" }, exitView == "update-name-minor"
                ? content.common.ok
                : content.common.done))));
}
var mapStateToProps = function (_a) {
    var content = _a.content, account = _a.account, route = _a.route;
    return ({
        content: content,
        account: account,
        route: route,
    });
};
exports.default = react_redux_1.connect(mapStateToProps)(UpdateNameSuccess);
